// NavigationContext.js
import { createContext, useContext } from 'react'
import { useState } from 'react'

// 1. Create a Context object
const NavigationContext = createContext()

// 2. Create a custom hook that uses that context
export function useNavigationContext() {
  const context = useContext(NavigationContext)
  if (!context) {
    throw new Error('useNavigationContext must be used within a NavigationProvider')
  }
  return context
}

// 3. Create a Provider component (also exported)
export function NavigationProvider({ children }) {
  const [navigationData, setNavigationData] = useState(null)

  // Add the clear function
  const clearNavigationData = () => {
    setNavigationData(null)
  }
  
  return (
    <NavigationContext.Provider value={{ 
      navigationData, 
      setNavigationData, 
      clearNavigationData 
    }}>
      {children}
    </NavigationContext.Provider>
  )
}